import { studentQuestionStore } from './store.js';
import { renderQuestionModule, updateTotalCount } from './render.js';
import { saveQuestion } from './ajax.js';
import { getSelectedFiles, clearFiles } from './attachment.js';
import { refreshQuestions } from './list.js';

/**
 * Initialize the question submission form
 */
export function initQuestionForm() {
	const submitBtn = document.getElementById('btn-submit-question');
	const textarea = document.getElementById('student-question-content');

	if (!submitBtn || !textarea) return;

	submitBtn.addEventListener('click', async (e) => {
		e.preventDefault();

		const content = textarea.value.trim();
		if (!content) {
			const contentWrapper = textarea.closest('.textarea-container');
			contentWrapper.classList.add('error');
			contentWrapper.querySelector('.form-helper-text').textContent = wpcore.direct_t({ en: 'Your response is required.', fr: 'Votre r\u00e9ponse est requise.' });
			return;
		}

		submitBtn.disabled = true;
		submitBtn.textContent = wpcore.direct_t({ en: 'Sending...', fr: 'Envoi en cours...' });

		const files = getSelectedFiles();
		const result = await saveQuestion({ content, files });

		if (result.success) {
			wpcore.alert('success', wpcore.direct_t({ en: 'Send Question', fr: 'Envoyer la question' }), wpcore.direct_t({ en: 'Your question has been sent successfully!', fr: 'Votre question a \u00e9t\u00e9 envoy\u00e9e avec succ\u00e8s !' }));

			// Clear form
			textarea.value = '';
			clearFiles();

			// Close popup
			wpcore.closePopup('send-question');

			// Refresh list
			refreshQuestions();
		} else {
			const errorMsg = (result.data && result.data.message) || result.message || wpcore.direct_t({ en: 'Failed to send question. Please try again.', fr: '\u00c9chec de l\'envoi de la question. Veuillez r\u00e9essayer.' });
			wpcore.alert('error', wpcore.direct_t({ en: 'Send Question', fr: 'Envoyer la question' }), errorMsg);
		}

		submitBtn.disabled = false;
		submitBtn.textContent = wpcore.direct_t({ en: 'Send Question', fr: 'Envoyer la question' });
	});
}

/**
 * Handle filter change event
 * @param {Event} e - Change event
 * @param {HTMLElement} container - List container
 */
export function handleFilterChange(e) {
	const status = e.target.value;
	const filteredQuestions = studentQuestionStore.getQuestionsByStatus(status);
	const totalQuestions = studentQuestionStore.getQuestions().length;
	renderQuestionModule({
		questions: filteredQuestions,
		userRole: studentQuestionStore.getUserRole(),
		totalQuestions
	});
	updateTotalCount(filteredQuestions.length);
}

/**
 * Handle click events via event delegation
 * @param {Event} e - Click event
 */
export function handleClick(e) {
	const item = e.target.closest('.student-question-item');
	if (!item) return;

	const id = item.getAttribute('data-id');
	if (!id) return;

	selectQuestion(id);
}

/**
 * Handle question selection
 * @param {string} id - Question ID
 */
function selectQuestion(id) {

	if (!id) {
		return;
	}

	studentQuestionStore.setCurrentQuestion(id);

	updateActiveItem(id);

	// Trigger update detail view
	import('./detail.js').then(({ renderQuestionDetail }) => {
		renderQuestionDetail(id);
	});

	handleMobileNav(true);
}

/**
 * Handle mobile navigation
 * @param {boolean} showDetail - Show detail view
 */
export function handleMobileNav(showDetail) {
	const listWrapper = document.getElementById('list-question');
	const detailWrapper = document.getElementById('detail-question');

	if (!listWrapper || !detailWrapper) return;

	// Desktop: Always show both
	if (window.innerWidth >= 1024) {
		listWrapper.classList.remove('hidden');
		detailWrapper.classList.remove('hidden');
		return;
	}

	// Mobile logic
	if (showDetail) {
		listWrapper.classList.add('hidden');
		detailWrapper.classList.remove('hidden');
	} else {
		listWrapper.classList.remove('hidden');
		detailWrapper.classList.add('hidden');
	}
}

/**
 * Update active state for list items
 * @param {string} id - Active Question ID
 */
function updateActiveItem(id) {
	const items = document.querySelectorAll('.student-question-item');
	items.forEach(item => {
		const itemId = item.getAttribute('data-id');
		if (String(itemId) === String(id)) {
			// Active state
			item.classList.add('border-primary-500', 'bg-primary-100');
			item.classList.remove('border-gray-100', 'bg-white');
		} else {
			// Normal state
			item.classList.add('border-gray-100', 'bg-white');
			item.classList.remove('border-primary-500', 'bg-primary-100');
		}
	});
}

/**
 * Initialize resize handler to fix layout issues when switching between mobile and desktop
 */
export function initResizeHandler() {
	let isDesktop = window.innerWidth >= 1024;

	window.addEventListener('resize', () => {
		const currentIsDesktop = window.innerWidth >= 1024;

		// Only act if breakpoint changed
		if (currentIsDesktop !== isDesktop) {
			isDesktop = currentIsDesktop;

			const listWrapper = document.getElementById('list-question');
			const detailWrapper = document.getElementById('detail-question');

			if (!listWrapper || !detailWrapper) return;

			if (isDesktop) {
				// Desktop: Show both
				listWrapper.classList.remove('hidden');
				detailWrapper.classList.remove('hidden');
			} else {
				// Mobile: Check if there is an active question
				const currentQuestion = studentQuestionStore.getCurrentQuestion();
				if (currentQuestion) {
					listWrapper.classList.add('hidden');
					detailWrapper.classList.remove('hidden');
				} else {
					listWrapper.classList.remove('hidden');
					detailWrapper.classList.add('hidden');
				}
			}
		}
	});

	// Run once on init to sure correct state if started in desktop but messed up?
	// No, init state is handled by PHP classes.
}
